import { KYMW1317Component } from './kymw1317.component';

/**
 * 企画連絡承認画面の値を管理するクラス
 *
 * @export KYMW1317Model
 * @class KYMW1317Model
 */
export class KYMW1317Model {
  kymw1317Component: KYMW1317Component;
  // public backgroundColor: string = <string>'white';
  public permission: string = <string>'';                   // 表示状態（0：編集モード、1：閲覧モード）
  public lockInfo: string = <string>'';                     // ロック情報（0：正常、1：エラー）
  public orderCode = '';                            // 受注コード
  public pCode = '';                                // Pコード
  public guideGoodsName = '';                       // 商品案内用商品名
  public guideStandardName = '';                    // 商品案内用規格名
  public kikakuRenrakuStatus = '';                  // 企画連絡ステータス
  public kikakuRenrakuStatusName = '';              // 企画連絡ステータス名
  public kikakuRenrakuStatusBgColor = '';           // 企画連絡ステータス背景色
  public selectedItemCode = '';                     // 選択されているアイテムコード
  public supplierInformationList: Array<any> = [];          // 取引先連絡情報リスト
  public isDisabledMessageFromCoop = false;        // 生協よりの活性/非活性フラグ
  public approvalColumnList: Array<any> = [];               // 承認項目リスト
  public isDisabledReflect = false;                // 反映チェックボックス活性/非活性フラグ
  public isDisabledSkewer = true;                  // 串刺チェックボックス活性/非活性フラグ
  public buyerCheckboxVal = false;                 // バイヤーチェックボックスの値
  public isDisabledBuyerCheckbox = false;          // バイヤーチェックボックスの活性/非活性フラグ
  public editorCheckboxVal = false;                // 編集チェックボックスの値
  public isDisabledEditorCheckbox = false;         // 編集チェックボックスの活性/非活性フラグ
  public isDisabledApprovalButton = true;          // 承認ボタンの活性/非活性フラグ
  public isDisabledCoop = false;                   // 生協の数が合わないときのフラグ

  /**
   * サーバ取得データを反映する
   *
   * @param {*} serverData サーバ取得データ
   * @memberof KYMW1317Model
   */
  public updateKYMW1317(serverData: any): void {
    this.orderCode = serverData.CommonItem.OrderCode;
    this.pCode = serverData.CommonItem.PCode;
    this.guideGoodsName = serverData.CommonItem.GuideGoodsName;
    this.guideStandardName = serverData.CommonItem.GuideStandardName;
    this.kikakuRenrakuStatus = serverData.CommonItem.KikakuRenrakuStatus.trim();
    this.kikakuRenrakuStatusName = serverData.CommonItem.KikakuRenrakuStatusName;
    this.kikakuRenrakuStatusBgColor = `rgb(${serverData.CommonItem.KikakuRenrakuStatusBgColor})`;
    this.isDisabledCoop = serverData.CoopChanged === "true";
    if (serverData.hasOwnProperty('SupplierInformationList')) {
      this.supplierInformationList = serverData.SupplierInformationList.map(info => {
        return {
          itemCode: info.ItemCode,
          orderClientName: info.OrderClientName,
          kikakuRenrakuKakuninUserName: info.KikakuRenrakuKakuninUserName,
          dataCreateDay: info.DataCreateDay,
          messageFromClient: info.MessageFromClient,
          displayImageChangeIndication: info.DisplayImageChangeIndication,
          houzaiHenkouKanouseiAri: info.HouzaiHenkouKanouseiAri === '1',
          messageFromCoop: info.MessageFromCoop,
        }
      });
    }
    if (serverData.hasOwnProperty('ApprovalColumnList')) {
      this.approvalColumnList = serverData.ApprovalColumnList.map(column => {
        return {
          itemCode: column.ItemCode,
          approver: column.Approver === '1' ? '編集'
            : column.Approver === '2' ? 'バイヤー'
              : column.Approver === '3' ? 'バイヤー/編集' : '',
          reflectUnit: column.ReflectUnit,
          columnNo: column.ColumnNo.trim(),
          columnName: column.ColumnName,
          planContactData: column.PlanContactData,
          supplierFixData: column.SupplierFixData,
          current: column.Current,
          codeDiv: column.CodeDiv,
          codeSeqNo: column.CodeSeqNo,
          operationType: column.OperationType,
          unreflectColumn: column.UnreflectColumn,
          skeweredConfig: column.SkeweredConfig,
          ngWord: column.NgWord,
          isSkewer: false,
          isReflect: false,
          isDisabledSkewer: true,
          isDisabledReflect: column.UnreflectColumn === '1' // 反映できない項目の反映チェックボックスを非活性
        }
      });
    }
  }
}
